import { createRoot } from "react-dom/client";

import { ConfigProvider } from "antd";
import en_US from "antd/locale/en_US";

import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./i18n";

const root = createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <ConfigProvider
    locale={en_US}
    theme={{
      token: {
        colorPrimary: "#615742",
      },
      components: {
        // Button theme
        Button: {
          colorPrimary: "#8F805B",
          borderRadius: 27,
          colorPrimaryHover: "#DEC27D",
        },

        Layout: {
          //header theme
          headerBg: "white",
          colorText: "#6C6C6C",
          triggerBg: "#514B3D",
        },
        Menu: {
          // Sidebar them
          colorText: "#A6A6A6",
          colorLinkActive: "#CCC5B9",
          itemBg: "#403D39", // menu bg color
          itemSelectedColor: "white", // menu item selected text color
          itemBorderRadius: 0,
          colorPrimaryBorder: "6px solid green",
          itemHoverBg: "#95855F",
          itemHoverColor: "black",
        },
        Breadcrumb: {
          lastItemColor: "#0C377C",
          linkColor: "#0C377C",
          separatorColor: "#0C377C",
        },
        Input: {
          colorBorder: "#A6A6A6",
          borderRadius: 4,
        },
        Select: {
          colorBorder: "#A6A6A6",
          borderRadius: 4,
        },
      },
    }}
  >
    <App />
  </ConfigProvider>
);

reportWebVitals();
